import { render } from "./App.vue?vue&type=template&id=8f61d71c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8f61d71c&lang=css"

import exportComponent from "/Users/matt/websites/code-practice.test/portfolio/expense-tracker/vuecli/expense-tracker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__